import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon-line.svg';
import Icon, { IconProps } from 'approot/shared/icons/icon';

const IconLine = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconLine;
